import { render, staticRenderFns } from "./Inbound.vue?vue&type=template&id=4fb6a49c&scoped=true&"
import script from "./Inbound.vue?vue&type=script&lang=js&"
export * from "./Inbound.vue?vue&type=script&lang=js&"
import style0 from "./Inbound.vue?vue&type=style&index=0&id=4fb6a49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6a49c",
  null
  
)

export default component.exports